<template>
  <div>
    <div class="nav-title">
      Login/out
    </div>
    <div class="mt-1 px-2 flex flex-col gap-2">
      <QForm
        class="flex flex-nowrap gap-1"
        @submit.prevent="authStore.login(form)"
      >
        <div class="flex flex-col gap-2">
          <QInput
            v-model="form.username"
            placeholder="ID"
            outlined
            dense
            square
          >
            <template #prepend>
              <QIcon name="person" />
            </template>
          </QInput>
          <QInput
            v-model="form.password"
            placeholder="PASSWORD"
            type="password"
            outlined
            dense
            square
          >
            <template #prepend>
              <QIcon name="lock" />
            </template>
          </QInput>
        </div>
      </QForm>
      <div class="h-8 grid grid-cols-1">
        <QBtn
          type="submit"
          color="secondary"
          dense
          unelevated
          :loading="authStore.logging"
          class="w-full"
        >
          로그인
        </QBtn>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useAuthStore } from '@/stores/auth.js'
import { reactive } from 'vue'

const authStore = useAuthStore()

const form = reactive({
  username: '',
  password: ''
})
</script>
